module.exports = __webpack_public_path__ + "media/pressalit_1.f77be2e2.mp4";